// extracted by mini-css-extract-plugin
export default {"container":"Applicants_container__SM05i","section":"Applicants_section__XxizP","row":"Applicants_row__IHNt9","toggle":"Applicants_toggle__ZltyU"};